import { unzipSync } from 'fflate'

/** IFC dentro de um zip (`.ifczip`, ou um `.zip` com um `.ifc`).
 *
 *  Vive aqui, e não no carregador, porque há dois sítios que têm de
 *  chegar ao MESMO IFC a partir do mesmo zip: o carregador, que calcula
 *  o SHA-256 sobre o IFC extraído, e a reabertura pelo handle guardado
 *  (`ifcHandles.resolveStoredHandle`), que confere esse SHA. Quando a
 *  reabertura fazia o SHA do zip inteiro, um `.ifczip` intacto era
 *  sempre dado como "modificado no disco". */

/** Detect a ZIP container by magic bytes. ifczip files (and ordinary
 *  zips that wrap a single .ifc) begin with "PK\x03\x04": the local
 *  file header. We accept the whole "PK?" family to be lenient. */
export function looksLikeZip(bytes: Uint8Array): boolean {
  return (
    bytes.length >= 4 &&
    bytes[0] === 0x50 &&
    bytes[1] === 0x4b &&
    (bytes[2] === 0x03 || bytes[2] === 0x05 || bytes[2] === 0x07)
  )
}

/** Pick the largest .ifc entry inside a zip and return its bytes + the
 *  inner filename (so downstream sees the real .ifc name, not the
 *  outer .ifczip). Throws when there is no .ifc inside. */
export function extractIfcFromZip(
  zipBytes: Uint8Array,
): { name: string; bytes: Uint8Array } {
  const entries = unzipSync(zipBytes)
  // Prefer the largest .ifc entry: covers zips that bundle the model
  // alongside small companions (e.g. an XML metadata file). Tie-break
  // on alphabetical name for determinism.
  let best: { name: string; bytes: Uint8Array } | null = null
  for (const [name, data] of Object.entries(entries)) {
    if (!name.toLowerCase().endsWith('.ifc')) continue
    if (
      !best ||
      data.length > best.bytes.length ||
      (data.length === best.bytes.length && name < best.name)
    ) {
      best = {
        name: name.split('/').pop() || name,
        bytes: data,
      }
    }
  }
  if (!best) {
    throw new Error(
      'O ficheiro .ifczip não contém nenhum .ifc no seu interior.',
    )
  }
  return best
}
